export default __webpack_public_path__ + "static/media/home-ground.c0114ffb.png";